<template>
  <div class="nav-contaniner">
    <div class="nav-left">
      <CompanySelect />
    </div>
    <div class="nav-center">
      <UpgradePrompt />
    </div>
    <div class="nav-right">
      <slot name="navbar"></slot>
      <!-- 个人中心 -->
      <personal-center />
    </div>
  </div>
</template>
<script>
import personalCenter from './personalCenter.vue'
import CompanySelect from './CompanySelect'
import UpgradePrompt from './UpgradePrompt'

export default {
  name: 'Navbar',
  components: {
    personalCenter,
    CompanySelect,
    UpgradePrompt,
  },
  props: {
    // 子应用控制帮助中心是否展示
    // eslint-disable-next-line vue/no-unused-properties
    showHelpCenterBySub: {
      type: Boolean,
      default: false,
    },
    // welcome页不展示
    // eslint-disable-next-line vue/no-unused-properties
    isHelp: {
      type: Boolean,
      default: false,
    },
    helpNavClick: {
      type: Function,
    },
    // eslint-disable-next-line vue/no-unused-properties
    httpMethods: {
      type: Function,
    },
    // eslint-disable-next-line vue/no-unused-properties
    request: {
      type: Function,
    },
    // eslint-disable-next-line vue/no-unused-properties
    authUtils: {
      type: Object,
    },
  },
  provide() {
    return {
      openHelpCenterFun: this.helpNavClick,
    }
  },
}
</script>
<style lang="scss">
$--border-radius-large: 8px;
.nav-contaniner {
  position: absolute;
  width: calc(100% - 80px);
  top: 0;
  left: 80px;
  border-top-left-radius: $--border-radius-large !important;
  display: flex;
  justify-content: space-between;
  height: 48px;
  background-color: #fff;
  font-size: 14px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  padding: 0 32px;

  .nav-bar-item {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.85);
    border-radius: 5px;
    display: flex;
    align-items: center;
    .icon {
      margin-right: 2px;
    }
  }

  .nav-bar-item:hover {
    color: #276bec;
    background: #eef2fe;
  }

  .nav-left {
    display: flex;
    align-items: center;
  }

  .nav-center {
    display: flex;
    align-items: center;
  }

  .nav-right {
    display: flex;
    align-items: center;
  }
}
</style>
